
import React from 'react';
import { Container, Form, Button } from 'react-bootstrap';
import { motion } from 'framer-motion';

const Contact = () => {
  return (
    <section id="contact" className="contact-section py-5">
      <Container>
        <h2 className="text-center mb-4">Contact Us</h2>
        <br></br>
        <h3 className="text-center mb-4">We'd love to hear from you!<br></br>
        let us know what you think!!!</h3>
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.5 }}
        >
          <Form className="mx-auto" style={{ maxWidth: '500px' }}>
            <Form.Group controlId="formName">
              <Form.Label>Name</Form.Label>
              <Form.Control type="text" placeholder="Enter your name" />
            </Form.Group>

            <Form.Group controlId="formEmail" className="mt-3">
              <Form.Label>Email address</Form.Label>
              <Form.Control type="email" placeholder="Enter your email" />
            </Form.Group>

            <Form.Group controlId="formMessage" className="mt-3">
              <Form.Label>Message</Form.Label>
              <Form.Control as="textarea" rows={3} placeholder="Your message" />
            </Form.Group>

            <Button variant="primary" type="submit" className="mt-4 w-100">
              Submit
            </Button>
          </Form>
        </motion.div>
      </Container>
    </section>
  );
}

export default Contact;
